import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({
    name: Yup.string()
      .required('Field is required')
      .max(50, 'Group name must be between 1 and 50 characters'),
  });
};
